import { toast } from 'sonner';

function drawCard(ctx, size, { rank, name, points, eliminations, winnings, periodLabel }, emblem, story) {
  const W = story ? 1080 : size;
  const H = story ? 1920 : size;
  const s = H / 1080;

  ctx.fillStyle = '#0d0d0d';
  ctx.fillRect(0, 0, W, H);

  const glow = ctx.createRadialGradient(W / 2, 140 * s, 40, W / 2, 140 * s, 720 * s);
  glow.addColorStop(0, 'rgba(232,23,58,0.38)');
  glow.addColorStop(1, 'rgba(232,23,58,0)');
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  ctx.strokeStyle = 'rgba(255,255,255,0.045)';
  ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 64) {
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, H);
    ctx.stroke();
  }
  for (let y = 0; y <= H; y += 64) {
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(W, y);
    ctx.stroke();
  }

  const cx = W / 2;
  const emblemSize = 190 * s;
  if (emblem) {
    try {
      ctx.drawImage(emblem, cx - emblemSize / 2, 64 * s, emblemSize, emblemSize);
    } catch {}
  }

  ctx.font = `italic 900 ${46 * s}px Inter, sans-serif`;
  const w1 = ctx.measureText('KROY ').width;
  const w2 = ctx.measureText('ESPORTS').width;
  const startX = cx - (w1 + w2) / 2;
  ctx.textAlign = 'left';
  ctx.fillStyle = '#e8173a';
  ctx.fillText('KROY ', startX, 330 * s);
  ctx.fillStyle = '#ffffff';
  ctx.fillText('ESPORTS', startX + w1, 330 * s);
  ctx.textAlign = 'center';

  ctx.font = `italic 900 ${180 * s}px Inter, sans-serif`;
  ctx.fillStyle = rank === 1 ? '#e8173a' : '#ffffff';
  ctx.fillText(`RANK #${rank}`, cx, 570 * s);

  ctx.font = `800 ${62 * s}px Inter, sans-serif`;
  ctx.fillStyle = '#ffffff';
  ctx.fillText(String(name).slice(0, 22), cx, 668 * s);

  const stat = `${points} PTS${eliminations ? `  •  ${eliminations} ELIMINATIONS` : ''}${winnings ? `  •  ₹${Number(winnings).toLocaleString('en-IN')}` : ''}`;
  ctx.font = `700 ${40 * s}px Inter, sans-serif`;
  const sw = ctx.measureText(stat).width;
  const pw = sw + 90 * s;
  const ph = 96 * s;
  const px = cx - pw / 2;
  const py = 726 * s;
  ctx.beginPath();
  ctx.roundRect(px, py, pw, ph, 48 * s);
  ctx.fillStyle = 'rgba(232,23,58,0.15)';
  ctx.fill();
  ctx.strokeStyle = 'rgba(232,23,58,0.6)';
  ctx.lineWidth = 3;
  ctx.stroke();
  ctx.fillStyle = '#e8173a';
  ctx.fillText(stat, cx, py + 63 * s);

  if (periodLabel) {
    ctx.font = `600 ${30 * s}px Inter, sans-serif`;
    ctx.fillStyle = '#8a8a8a';
    ctx.fillText(periodLabel.toUpperCase(), cx, 896 * s);
  }

  const footerY = story ? H - 120 : 986;
  ctx.font = `italic 900 ${36 * s}px Inter, sans-serif`;
  ctx.fillStyle = '#ffffff';
  ctx.fillText('kroyesports.com', cx, footerY);
  ctx.font = `600 ${23 * s}px Inter, sans-serif`;
  ctx.fillStyle = '#8a8a8a';
  ctx.fillText('DOWNLOAD THE APP  •  COMPETE  •  WIN REAL PRIZES', cx, footerY + 44 * s);
}

export async function shareRankCard(data, format = 'square') {
  try {
    const story = format === 'story';
    const canvas = document.createElement('canvas');
    canvas.width = 1080;
    canvas.height = story ? 1920 : 1080;
    const ctx = canvas.getContext('2d');

    try {
      await Promise.all([
        document.fonts.load('italic 900 190px Inter'),
        document.fonts.load('800 64px Inter'),
        document.fonts.load('700 40px Inter'),
      ]);
    } catch {}

    let emblem = null;
    try {
      emblem = new Image();
      emblem.src = '/kroy-emblem.png';
      await emblem.decode();
    } catch {
      emblem = null;
    }

    drawCard(ctx, 1080, data, emblem, story);

    const blob = await new Promise((r) => canvas.toBlob(r, 'image/png'));
    const file = new File([blob], `kroy-rank-${data.rank}${story ? '-story' : ''}.png`, { type: 'image/png' });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: `KROY Esports — Rank #${data.rank}`,
        text: `${data.name} hit Rank #${data.rank} on KROY Esports!`,
      });
      toast.success('Rank card shared!');
    } else {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      toast.success(story ? 'Story card downloaded!' : 'Rank card downloaded!');
    }
  } catch (err) {
    if (err?.name !== 'AbortError') toast.error('Could not create rank card');
  }
}
